import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { PumpRoomDesign } from '@authority-labs/api-interfaces';
import { MeasureType } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-pump-room-design-inspection',
  templateUrl: './pump-room-design-inspection.component.html',
  styleUrls: ['./pump-room-design-inspection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PumpRoomDesignInspectionComponent {
  @Input() data: PumpRoomDesign;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  poolingVolumeCharacteristics: MeasureType[] = [MeasureType.PoolingVolume];

  onDataChange(): void {
    this.dataChange.emit();
  }
}
